module.exports = __webpack_public_path__ + "img/191-Anthracite Grey 7016 Smooth 2.jpg";